import type { ReactNode } from 'react';

import { LocalizationProvider as MUILocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { frFR } from '@mui/x-date-pickers/locales';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';

export interface Props {
  children: ReactNode;
  locale: 'fr' | 'en';
}

const localeMap = {
  fr: frLocale,
  en: enLocale,
};

const LocalizationProvider = ({ children, locale }: Props) => (
  <MUILocalizationProvider
    dateAdapter={AdapterDateFns}
    adapterLocale={localeMap[locale]}
    localeText={
      locale === 'fr' ? frFR.components.MuiLocalizationProvider.defaultProps.localeText : undefined
    }
  >
    {children}
  </MUILocalizationProvider>
);

export default LocalizationProvider;
